import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { CustomCellEditorProps } from 'ag-grid-react';

interface MapSelectCellEditorParams extends CustomCellEditorProps {
    options: Record<string, string>;
}

export const MapSelectCellEditor = forwardRef((props: MapSelectCellEditorParams, ref) => {
    const [value, setValue] = useState(props.value);
    const options = props.options || {};

    useImperativeHandle(ref, () => ({
        getValue: () => value,
        isPopup: () => false, // Inline editor usually better for simple selects, but can be true if needed
    }));

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setValue(e.target.value);
        // Con reactiveCustomComponents=true, AG Grid solo detecta el cambio si se
        // notifica explícitamente vía onValueChange (getValue por ref ya no se usa).
        props.onValueChange(e.target.value);
    };

    // If the current value is not in the keys, maybe it's a new value or empty
    // We want to display the Description (Value) but save the Code (Key)
    // Actually, standard HTML select with value={key} shows the content of the option.

    return (
        <div className="w-full h-full bg-white">
            <select
                className="w-full h-full px-2 py-1 text-sm border-none focus:outline-none"
                value={value || ''}
                onChange={handleChange}
                onBlur={() => props.stopEditing()}
            >
                <option value="">Select...</option>
                {Object.entries(options).map(([key, label]) => (
                    <option key={key} value={key}>
                        {label}
                    </option>
                ))}
            </select>
        </div>
    );
});

MapSelectCellEditor.displayName = 'MapSelectCellEditor';
